import { Option, Select } from '@dealstack/frontend/shared/components/forms/Select/Select';
import { useTranslationDefault } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { memo } from 'react';
import styled from 'styled-components';
import { SecurityType } from '@dealstack/shared/lib/generated';

interface Props {
	className?: string;
	name: string;
}

const SecurityTypeSelect = ({ name, className }: Props) => {
	const tDefault = useTranslationDefault();
	return (
		<Select name={name} className={className}>
			<Option value={SecurityType.ORDINARY_SHARE}>
				{tDefault('security_types.ordinary_share')}
			</Option>
			<Option value={SecurityType.PREFERENCE_SHARE}>
				{tDefault('security_types.preference_share')}
			</Option>
			<Option value={SecurityType.LOAN}>{tDefault('security_types.loan')}</Option>
			<Option value={SecurityType.OPTIONS}>{tDefault('security_types.options')}</Option>
			<Option value={SecurityType.TRACKING_SHARE}>
				{tDefault('security_types.tracking_share')}
			</Option>
			<Option value={SecurityType.PARTNERSHIP_UNIT}>
				{tDefault('security_types.partnership_unit')}
			</Option>
			<Option value={SecurityType.VIRTUAL_EQUITY}>
				{tDefault('security_types.virtual_equity')}
			</Option>
			<Option value={SecurityType.WARRANT}>{tDefault('security_types.warrant')}</Option>
			<Option value={SecurityType.OTHER_EQUITY}>
				{tDefault('security_types.other_equity')}
			</Option>
			<Option value={SecurityType.OTHER}>{tDefault('security_types.other')}</Option>
		</Select>
	);
};

const Memoized = memo(SecurityTypeSelect);
const Styled = styled(Memoized)``;

export { Styled as SecurityTypeSelect };
